function Child(data){
    let child = data || {};
    this.birthDate = child.birthDate;
    this.isHandicaped = child.isHandicaped;  
}
module.exports = Child;